module.exports = __webpack_public_path__ + "img/即时风险.fe257fd2.png";